import { UsePaymentsModalButtonReturnType } from '../../../hooks';
import { MultiCollectSelectInvoiceModal } from './multi-collect-select-invoice-modal';
import {
  SelectInvoiceModalCommonProps,
  SingleProcessorSelectInvoiceModal,
} from './single-processor-select-invoice-modal';

export type MessagingSelectInvoiceModalProps = SelectInvoiceModalCommonProps & {
  showMultiProcessorCollect: boolean;
  Tooltip: UsePaymentsModalButtonReturnType['Tooltip'];
};

export const MessagingSelectInvoiceModal = ({
  showMultiProcessorCollect,
  Tooltip,
  ...rest
}: MessagingSelectInvoiceModalProps) => {
  return (
    <>
      {showMultiProcessorCollect ? (
        <MultiCollectSelectInvoiceModal {...rest} />
      ) : (
        <SingleProcessorSelectInvoiceModal {...rest} />
      )}
      {Tooltip}
    </>
  );
};
